export const spaces = {
  small: '4px',
  medium: '8px',
  large: '16px',
};
